import { Injectable } from '@angular/core';
import { PurchasesByPeriodPrintingQuery, PurchasesByPeriodPrintingQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchasesByPeriodPrintingQuery)
@Wrapper(PurchasesByPeriodPrintingQueryHandlerBase)
export class PurchasesByPeriodPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
